export const WELL_BEING_SLIDERS = [
  { original: '/images/well-being/sliders/1.png' },
  { original: '/images/well-being/sliders/2.png' },
  { original: '/images/well-being/sliders/3.png' },
  { original: '/images/well-being/sliders/4.png' },
  { original: '/images/well-being/sliders/5.png' },
  { original: '/images/well-being/sliders/6.png' },
  { original: '/images/well-being/sliders/7.png' },
]
